export default __webpack_public_path__ + "static/media/gallery_04.cedbc5a0.jpg";